import React, { useState } from "react";
import styled from "styled-components";
import Destination1 from "../assets/gorilla.jpg";
import Destination2 from "../assets/Mtelgon-Park.jpg";
import Destination3 from "../assets/Semuliki-National-Park.jpg";
import Destination4 from "../assets/Kidepo-Valley-Wilderness.jpg";
import Destination5 from "../assets/Murchison-Falls-Park.jpg";
import Destination6 from "../assets/Queen-Elizabeth-National-Park.jpg";
import Destination7 from "../assets/rwenzori-mt-trekking.jpg";
import Destination8 from "../assets/source-of-the-nile.jpeg";
import Destination9 from "../assets/kampala-city.jpeg";
// import info1 from "../assets/info1.png";
// import info2 from "../assets/info2.png";
// import info3 from "../assets/info3.png";

export default function Recommend() {
	const data = [
		{
			image: Destination1,
			title: "Bwindi Gorilla Forest",
			subTitle: "Home to half of the world’s mountain gorillas!",
			cost: "38,800",
			duration: "Approx 2 night trip",
			distance: "3315sq",
		},
		{
			image: Destination2,
			title: "Mount Elgon National Park",
			subTitle:
				"Has a wide variety of wildlife, from elephants,buffalos, monkeys and more. The park is home to over 300 species of birds as well",
			cost: "54,200",
			duration: "Approx 2 Nights, 3 Days",
			distance: "4000km2",
		},
		{
			image: Destination3,
			title: "Semiliki National Park",
			subTitle:
				"This is one of Africa’s most ancient and bio-diverse forests; one of the few to survive the last ice age.",
			cost: "45,500",
			duration: "Approx 2 Nights, 3 Days",
		},
		{
			image: Destination4,
			title: "Kidepo National Park",
			subTitle:
				"Traversed by large sand rivers, the park is renowned for its distinctive composition of wild game co- existing with the dry mountain forests, open savanna and hilltops capped by rock kopjes.",
			cost: "24,100",
			duration: "Approx 3 Nights, 4 Days",
		},
		{
			image: Destination5,
			title: "Murchison Falls Game Park",
			subTitle:
				"Uganda’s largest and oldest conservation area, hosting 76 species of mammals and over 450 birds.",
			cost: "95,400",
			duration: "Approx 2 Nights, 3 Days",
		},
		{
			image: Destination6,
			title: "Queen Elizabeth National park",
			subTitle:
				"The ideal habitat for classic big game, ten primate species including chimpanzees and over 600 species of birds.",
			cost: "38,800",
			duration: "Approx 3 Nights, 4 Days",
		},
		{
			image: Destination7,
			title: "Rwenzori Mountain Trekking",
			subTitle: "Feel the breeze as you take a hike up the Rwenzori Mountain",
			cost: "38,800",
			duration: "Approx 7 to 14 Days",
		},
		{
			image: Destination8,
			title: "Source of the Nile",
			subTitle:
			  "You will visit source of the nile, and trace origin of the world's longest river ",
			cost: "38,800",
			duration: "Approx 1 Day",
		  },
		  {
			image: Destination9,
			title: "Kampala City Tour",
			subTitle:
			  "You will visit places such as Namirembe cathedral, uganda museum, kibuli mosque, mabira forest ",
			cost: "38,800",
			duration: "Approx 1 Day",
		  },
	];

	const packages = [
		"The Weekend Break",
		"The Package Holiday",
		"The Group Tour",
		"Long Term Slow Travel",
	];

	const [active, setActive] = useState(1);
	return (
		<Section id="recommend">
			<div className="title">
				<h2>Popular Destinations</h2>
			</div>
			{/* <div className="packages">
        <ul>
          {packages.map((pkg, index) => {
            return (
              <li
                className={active === index + 1 ? "active" : ""}
                onClick={() => setActive(index + 1)}
              >
                {pkg}
              </li>
            );
          })}
        </ul>
      </div> */}
			<div className="destinations">
				{data.map((destination) => {
					return (
						<div className="destination">
							<img src={destination.image} alt="" />
							<h3>{destination.title}</h3>
							<p>{destination.subTitle}</p>
							{/* <div className="info">
                <div className="services">
                  <img src={info1} alt="" />
                  <img src={info2} alt="" />
                  <img src={info3} alt="" />
                </div>
                <h4>{destination.cost}</h4>
              </div> */}
							<div className="distance">
								<span>{destination.distance}</span>
								<span>{destination.duration}</span>
							</div>
						</div>
					);
				})}
			</div>
		</Section>
	);
}

const Section = styled.section`
	padding: 2rem 0;
	.title {
		text-align: center;
		padding-bottom: 1rem;
		color: #276d9b;
	}
	.packages {
		display: flex;
		justify-content: center;
		margin: 2rem 0;
		ul {
			display: flex;
			list-style-type: none;
			width: max-content;
			li {
				padding: 1rem 2rem;
				border-bottom: 0.1rem solid black;
			}
			.active {
				border-bottom: 0.5rem solid #8338ec;
			}
		}
	}
	.destinations {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 3rem;
		padding: 0 3rem;
		.destination {
			text-transform: capitalize;
			padding: 1rem;
			display: flex;
			flex-direction: column;
			gap: 0.5rem;
			//background-color: #8338ec14;
			background-color: #d1e7f6;
			border-radius: 1rem;
			transition: 0.3s ease-in-out;
			&:hover {
				transform: translateX(0.4rem) translateY(-1rem);
				box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
			}
			img {
				width: 100%;
				border-radius: 0.5rem;
				height: 90%;
			}
			.info {
				display: flex;
				align-items: center;
				.services {
					display: flex;
					gap: 0.3rem;
					img {
						border-radius: 1rem;
						background-color: #4d2ddb84;
						width: 2rem;
						/* padding: 1rem; */
						padding: 0.3rem 0.4rem;
					}
				}
				display: flex;
				justify-content: space-between;
			}
			.distance {
				display: flex;
				justify-content: space-between;
				margin-top: 20px;
			}
		}
	}
	@media screen and (min-width: 280px) and (max-width: 768px) {
		.packages {
			ul {
				li {
					padding: 0 0.5rem;
					font-size: 2vh;
					padding-bottom: 1rem;
				}
				.active {
					border-bottom-width: 0.3rem;
				}
			}
		}
		.destinations {
			grid-template-columns: 1fr;
			padding: 0;
		}
	}
`;
